module.exports = __webpack_public_path__ + "static/img/Social-innovation-to-tackle-fuel-poverty.56f590a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/thumbnails/Social-innovation-to-tackle-fuel-poverty.jpg
// module id = p2OJ
// module chunks = 0